<template>
    <app-layout>
        <page-header title="Subscriptions" title-in-app-header>
            <filter-bar v-model="queryParams" :config="filterBarConfig" />
        </page-header>
        <div class="table-responsive max-h-[calc(100vh-300px)] overflow-y-auto rounded">
            <table class="table-striped table-hover table-bordered sticky top-0 table border">
                <thead>
                    <tr>
                        <th class="p-2 align-middle"><div class="w-80">Email</div></th>
                        <th v-for="type in notification_types.data" :key="type.value" :colspan="channels.data.length" class="p-2 align-middle">
                            <div :title="type.label" class="line-clamp-2 h-auto w-24 text-center">{{ type.label }}</div>
                        </th>
                    </tr>
                    <tr>
                        <th><div class="w-80"></div></th>
                        <template v-for="type in notification_types.data" :key="type.value">
                            <th v-for="channel in channels.data" :key="channel.value" :title="channel.label" class="text-center">
                                <div class="w-10">
                                    <icon v-if="channel.value === 'database'" name="cil-bell" />
                                    <span v-else-if="channel.value === 'mail'">@</span>
                                    <span v-else>{{ channel.label }}</span>
                                </div>
                            </th>
                        </template>
                    </tr>
                </thead>
            </table>
            <infinite-scroll #default="{ loadingPrevious, loadingNext }" data="subscriptions" items-element="#table-body" preserve-url>
                <table class="table-striped table-hover table-bordered table border">
                    <tbody id="table-body">
                        <tr v-if="loadingPrevious">
                            <td :colspan="columnCount">
                                <div class="text-center"><spinner /></div>
                            </td>
                        </tr>
                        <tr v-for="sub in subscriptions.data" :key="sub.id">
                            <td>
                                <div class="w-80 truncate">{{ sub.email.toLowerCase() }}</div>
                            </td>

                            <template v-for="type in notification_types.data" :key="type.value">
                                <template v-for="channel in channels.data" :key="channel.value">
                                    <td class="align-center text-center">
                                        <div class="w-10">
                                            <span
                                                v-if="isSubscribed(sub, type.value, channel.value)"
                                                class="bg-success rounded-circle inline-flex h-6 w-6 items-center justify-center"
                                            >
                                                <icon class="text-white" icon="cil-check-alt" />
                                            </span>
                                            <span v-else class="rounded-circle inline-flex h-6 w-6 items-center justify-center bg-danger">
                                                <icon class="text-white" icon="cil-x" />
                                            </span>
                                        </div>
                                    </td>
                                </template>
                            </template>
                        </tr>
                        <tr v-if="subscriptions.data.length === 0">
                            <td :colspan="columnCount">No subscriptions found</td>
                        </tr>
                        <tr v-if="loadingNext">
                            <td :colspan="columnCount">
                                <div class="text-center"><spinner /></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </infinite-scroll>
        </div>
    </app-layout>
</template>
<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { InfiniteScroll } from '@inertiajs/vue3';
import { computed, ref } from 'vue';
import Spinner from '@/Components/Spinner.vue';
import PageHeader from '@/Components/PageHeader.vue';
import FilterBar from '@/Components/FilterBar.vue';
import { trans } from '@/mixins/i18n.js';

const queryParams = ref(null);
const props = defineProps(['subscriptions', 'channels', 'notification_types']);

const filterBarConfig = {
    route: route('subscriptions.index'),
    routeOptions: { reset: ['subscriptions'] },

    filters: [
        { type: 'search', key: 'search', placeholder: trans('tasks.overview.filter.search') },
        { type: 'multi-select', key: 'notification_types', label: 'Types', options: props.notification_types.data },
        { type: 'multi-select', key: 'channels', label: 'Channels', options: props.channels.data },
    ],
};

const isSubscribed = (sub, type, channel) => sub[type + '_' + channel] === 1;
const columnCount = computed(() => props.notification_types.data.length * props.channels.data.length);
</script>
